import { Row } from '@deere/ux.uxframe-react';
import styled, { css } from 'styled-components';
import Colors from './color';

export const GlobalStyle = css`
  * {
    font-family: 'Noto Sans', sans-serif;
  }

  .error {
    input {
      border-color: #c21020 !important;
    }
  }
  body {
    background: ${Colors.bgGray};
    margin: 0 auto;
    max-width: 1440px;
  }
  .custom-container {
    width: 1320px !important;
    margin: auto !important;
  }
  .uxf-top-nav .navbar-nav {
    max-width: 1352px;
    margin: auto;
  }
  .modal-width {
    &,
    & > .modal-content {
      max-width: 914px;
      width: 100%;
      border-radius: 4px;
    }
  }
  .create-cr-modal {
    &,
    & > .modal-content {
      max-width: 1025px;
    }
  }
  .sm-modal-width {
    &,
    & > .modal-content {
      max-width: 690px;
      width: 100%;
      border-radius: 4px;
      max-height: 100% !important;
    }
  }
  .v-center {
    min-height: 100%;
    min-height: 100vh;
    display: flex;
    align-items: center;
  }

  .spinner-center {
    height: 100vh;
    position: fixed;
    z-index: 1075;
    top: 0;
    left: 0;
    right: 0;
  }
  .tab-pane {
    min-height: 420px;
    height: 100% !important;
    padding: 28px 36px !important;
  }
  .jdf-custom-select {
    .form-control {
      padding: 0px !important;
      & > div {
        border: 0 !important;
        background: none !important;
        position: relative;
        top: -1px;
      }
    }
    .jdf-custom-select__dropdown-indicator {
      color: #333 !important;
    }
    .jdf-custom-select__indicator-separator {
      display: none;
    }
    .jdf-custom-select__clear-indicator ~ .jdf-custom-select__indicator-separator {
      display: block !important;
    }
    jdf-custom-select__control.jdf-custom-select__control--menu-is-open {
      .jdf-custom-select__dropdown-indicator {
        background: var(--green);
        color: var(--white) !important;
      }
    }
    .jdf-custom-select__control--is-focused {
      border-color: #367c2b;
      outline: 0;
      box-shadow: 0 0 0 0.1875rem rgba(54, 124, 43, 0.25);
    }
    .jdf-custom-select__menu-list {
      background: #fff;
      border: 1px solid black;
      width: calc(100% + 2px);
      border-top: 0px;
      left: -1px;
      top: -7px;
      .jdf-custom-select__option--is-selected {
        background-color: var(--uxf-green) !important;
      }
    }
    .jdf-custom-select__option--is-focused {
      color: #fff;
      background-color: var(--info) !important;
    }
  }
  html {
    overflow: scroll;
    overflow-x: hidden;
  }
  hr {
    margin-top: 10px !important;
  }
  .hide-tooltip {
    display: none !important;
  }
  .remove-border {
    &:focus {
      box-shadow: none;
    }
  }
  .error-border {
    border-color: #c21020 !important;
  }
  .dark-bg {
    background: #f7f7f7;
  }
  .comment-width {
    width: 100%;
    max-width: 690px;
  }
  .employee-width {
    width: 100%;
    max-width: 1025px;
  }
  .tooltip-inner {
    max-width: 400px !important;
  }
  select.error {
    border-color: #c21020;
  }
  select.error:focus {
    border-color: #c21020 !important;
    outline: 0;
    box-shadow: 0 0 0 0.1875rem #c2102030 !important;
  }
  .menu-dot {
    padding: 0px;
    border: none;
    background: #fff;
    &:hover {
      color: #fff;
      background-color: transparent;
      border-color: transparent;
    }
    &:focus {
      box-shadow: none;
    }
    &::after {
      display: none;
    }
  }
  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin: 0;
  }
  ::-webkit-scrollbar {
    width: 0px;
  }

  .table-responsive,
  .all-card {
    &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      background-color: #ccc;
    }

    &::-webkit-scrollbar {
      width: 10px;
      background-color: #aaa;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #ccc;
    }
    overflow-y: auto;
    thead th {
      position: sticky !important;
      top: 0;
      border-top: 0px;
    }
  }
  .custom-home-icon {
    height: 42px !important;
    a {
      padding-bottom: 0px !important;
      img {
        top: 0px !important;
      }
    }
  }
`;

export const CustomContainer = styled(Row)`
  width: 1320px !important;
  margin: auto !important;
  > div {
    width: 100%;
  }
`;
